import BaseRepository from '@/api/repositories/BaseRepository';
import store from '@/store/index';

export default class SpecialOfferRepository extends BaseRepository {
	getOffers(page, paginate) {
		return this.get('specialOffers', { page: page, paginate: paginate });
	}

	storeOffer(data) {
		return this.post('specialOffers', {}, data);
	}

	deleteOffer(id) {
		return this.delete(`specialOffers/${id}`);
	}

	getOfferById(id) {
		return this.get(`specialOffers/${id}`, {});
	}

	updateOffer(id, data) {
		return this.put(`specialOffers/${id}`, {}, data);
	}

	applyFilters(data) {
		return this.post('specialOffers/applyFilters', {}, data);
	}

	getFilters() {
		return this.get('getSpecialOffersFilters', {});
	}
}
